import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  popoverPaper: {
    width: 320,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100, // Ajustado conforme imagem
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    borderRadius: 8,
    padding: theme.spacing(2),
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2)
  },
  iconContainer: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_50.main,
    borderRadius: 6,
    padding: 8,
    marginRight: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  iconButton: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.white_100.main,
    '& span': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 4
    },
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.yellow_500.main
          : theme.palette.white_100.main
    }
  },
  zapIcon: {
    color: theme.palette.yellow_500.main
  },
  optionButton: {
    width: '100%',
    justifyContent: 'center',
    textTransform: 'none',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_100.main,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    border:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
    marginBottom: theme.spacing(1),
    '&:hover': {
      border: `1px solid ${theme.palette.blue_300.main}`,
      color: theme.palette.white_100.main,
      backgroundColor: theme.palette.blue_300.main
    },
    '&.selected': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      borderColor: theme.palette.blue_300.main,
      backgroundColor: 'rgba(33, 150, 243, 0.05)'
    }
  },
  infoBox: {
    display: 'flex',
    backgroundColor: theme.palette.blue_300.main + '1A',
    border: `1px solid ${theme.palette.blue_300.main}`,
    borderRadius: 4,
    color: theme.palette.blue_300.main,
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  infoText: {
    fontSize: '0.8rem',
    color: '#a0a0a0'
  },
  closeButton: {
    width: '100%',
    textTransform: 'none',
    color: '#ffffff',
    borderTop: '1px solid #30363d',
    paddingTop: theme.spacing(1)
  }
}))
